import * as yup from 'yup';

import { getCurrentYear } from 'helpers/date.helpers';

import { DATE_REGEX } from 'containers/admin/clients/client/tabs-components/monitoring-settings-modal/monitoring-settings.constants';
import type { YearOption } from 'containers/admin/clients/client/tabs-components/monitoring-settings-modal/monitoring-settings.constants';

export const getCurrentFiscalYear = (): number => getCurrentYear();

export const generateYear1Options = (): YearOption[] => {
  const current = getCurrentYear();
  const years: YearOption[] = [];

  for (let y = current - 1; y >= current - 2; y -= 1) {
    years.push({ label: String(y), value: y });
  }

  return years;
};

export const toDate = (v: string | null | undefined): Date | null => {
  if (!v || !DATE_REGEX.test(v)) return null;

  const [m, d, y] = v.split('/').map(Number);

  return new Date(2000 + y, m - 1, d);
};

export const validationSchema = yup.object({
  inquiriesToApps: yup
    .string()
    .matches(DATE_REGEX, 'Enter full date in format mm/dd/yy')
    .required('Date is required'),
  applicationsToAdmits: yup
    .string()
    .matches(DATE_REGEX, 'Enter full date in format mm/dd/yy')
    .required('Date is required')
    .test(
      'is-after-inquiries',
      'Date must be later than previous stage',
      function (value) {
        const { inquiriesToApps } = this.parent;

        if (
          !value ||
          !DATE_REGEX.test(value) ||
          !DATE_REGEX.test(inquiriesToApps)
        ) {
          return true;
        }

        const a = toDate(value);
        const b = toDate(inquiriesToApps);

        if (!a || !b) return true;

        return a.getTime() > b.getTime();
      }
    ),
  admitsToEnrollment: yup
    .string()
    .matches(DATE_REGEX, 'Enter full date in format mm/dd/yy')
    .required('Date is required')
    .test(
      'is-after-applications',
      'Date must be later than previous stage',
      function (value) {
        const { applicationsToAdmits } = this.parent;

        if (
          !value ||
          !DATE_REGEX.test(value) ||
          !DATE_REGEX.test(applicationsToAdmits)
        ) {
          return true;
        }

        const a = toDate(value);
        const b = toDate(applicationsToAdmits);

        if (!a || !b) return true;

        return a.getTime() > b.getTime();
      }
    ),
});
